import React from 'react';

const Loading = () => {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(4px)',
      }}
      aria-label="Carregando"
      role="status"
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 50 50"
        style={{
          animation: 'maptrees-spin 1s linear infinite',
        }}
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="#e5e7eb"
          strokeWidth="4"
        />
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="#2d6a4f"
          strokeWidth="4"
          strokeDasharray="80"
          strokeDashoffset="60"
          strokeLinecap="round"
        />
      </svg>
      <style>{`
        @keyframes maptrees-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <p
        style={{
          color: '#2d6a4f',
          fontSize: '14px',
          fontWeight: '500',
          marginTop: '12px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          textAlign: 'center',
        }}
      >
        Carregando...
      </p>
    </div>
  );
};

export default Loading;
